export type AssetSharingPermissions = {
  shareAttributes?: boolean;
  shareJobHistory?: boolean;
  shareDeploymentHistory?: boolean;
};

export type AssetViewTab = {
  key: 'attributes' | 'jobs' | 'history';
  label: string;
  visible: boolean;
};

export function buildAssetViewTabs(
  sharingPermissions?: AssetSharingPermissions
): AssetViewTab[] {
  if (sharingPermissions === undefined) {
    return [
      { key: 'attributes', label: 'Attributes', visible: true },
      { key: 'jobs', label: 'Jobs', visible: true },
      { key: 'history', label: 'History', visible: true },
    ];
  }

  return [
    {
      key: 'attributes',
      label: 'Attributes',
      visible: sharingPermissions.shareAttributes !== false,
    },
    {
      key: 'history',
      label: 'History',
      visible:
        sharingPermissions.shareJobHistory !== false ||
        sharingPermissions.shareDeploymentHistory === true,
    },
  ];
}

export function getVisibleAssetViewTabs(
  sharingPermissions?: AssetSharingPermissions
): AssetViewTab[] {
  return buildAssetViewTabs(sharingPermissions).filter((tab) => tab.visible);
}

export function getSelectedAssetViewTabKey(
  visibleTabs: AssetViewTab[],
  selectedTabIndex: number
): AssetViewTab['key'] {
  return visibleTabs[selectedTabIndex]?.key || 'attributes';
}
